import { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function SellNUC() {
    const initialFormData = {
        wallet_id: "",
        amount_to_sell: "",
        name: "",
        mobile_number: "",
        email: "",
        preferred_stablecoin: "",
        country_of_residence: "",
        kyc_verification_status: "",
        kyc_image: null,
        selfie_image: null,
        is_miner: "no",
        miner_position: "",
    };

    const [formData, setFormData] = useState(initialFormData);
    const [formErrors, setFormErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const MAX_FILE_SIZE_MB = 10;

    const handleChange = (e) => {
        const { name, type, files, value } = e.target;

        if (type === "file") {
            const file = files[0];
            if (file && file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
                setFormErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: `File size should not exceed ${MAX_FILE_SIZE_MB}MB`,
                }));
                return;
            } else {
                setFormErrors(prevErrors => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }

            setFormData({
                ...formData,
                [name]: file,
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.wallet_id) errors.wallet_id = "Wallet ID is required";
        if (!formData.amount_to_sell || parseFloat(formData.amount_to_sell) > 50000) errors.amount_to_sell = "Maximum 50,000 NUC required";
        if (!formData.name) errors.name = "Name is required";
        if (!formData.mobile_number) errors.mobile_number = "Mobile number is required";
        if (!formData.email) errors.email = "Email is required";
        if (!formData.preferred_stablecoin) errors.preferred_stablecoin = "Stablecoin preference is required";
        if (!formData.country_of_residence) errors.country_of_residence = "Country is required";
        if (!formData.kyc_verification_status) errors.kyc_verification_status = "KYC status is required";
        if (!formData.kyc_image) errors.kyc_image = "Identification document is required";
        if (!formData.selfie_image) errors.selfie_image = "Selfie image is required";
        if (formData.is_miner === "yes" && !formData.miner_position) {
            errors.miner_position = "Miner position is required";
        }
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage(null);
        setSuccessMessage(null);

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            setLoading(false);
            return;
        }

        setFormErrors({});

        const formDataToSend = new FormData();
        for (const key in formData) {
            formDataToSend.append(key, formData[key]);
        }

        try {
            const response = await fetch('https://crypto-co.nugenesisou.com/otc-sale/sell-nuc', {
                method: 'POST',
                body: formDataToSend,
                headers: { 'accept': 'application/json' },
            });

            const data = await response.json();
            setLoading(false);

            if (data.message === "Sale submitted successfully") {
                setSuccessMessage("Your NUC sale has been successfully submitted!");
                setFormData(initialFormData);
            } else {
                const errorMessage = data.detail || "Failed to submit the sale. Please try again.";
                setErrorMessage(errorMessage);
            }
        } catch (error) {
            setLoading(false);
            setErrorMessage("An error occurred. Please try again.");
        }
    };

    return (
        <>
            <Header />
            <main style={{ backgroundColor: '#000', minHeight: '50vh', padding: '6rem 0 0 0' }}>

                <section className="pad breadcrumbs top-cover">
                    <div id="breadcrumb" className="content">
                        <a href="Home">Home</a><i></i>
                        <span>Product</span>
                    </div>
                </section>

                <section className="web3bank simple projects" style={{ minHeight: 'unset !important', maxWidth: '100%', margin: 'auto', borderRadius: '8px', padding: '2rem', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)' }}>
                    <h2 style={{ paddingBottom: '31px', color: '#0cc2ff', textAlign: 'center', marginBottom: '1rem', fontFamily: 'Infynyte', fontSize: '4rem', fontWeight: 600, textTransform: 'lowercase' }}>
                        Sell Your NuCoin (NUC) – OTC Buyback Available
                    </h2>

                    <p style={{ fontSize: '23px', textAlign: 'center', color: '#fff', marginBottom: '1rem' }}>
                        Looking to sell large volumes of NUC? We are currently facilitating Over-the-Counter (OTC) buyback deals for holders who wish to sell 10,000 NUC or more in a single transaction.
                    </p>

                    <p style={{ fontSize: '23px', textAlign: 'center', color: '#fff' }}>
                        Why Use Our OTC Buyback Service?
                        <br />
                        No slippage or public market impact
                        <br />
                        Fast and secure settlement
                        <br />
                        Transparent pricing (Quote will be supplied on OTC offer sheet)
                        <br />
                        Personalized support from our OTC team
                    </p>
                </section>

                <section className="web3bank simple projects" style={{ zIndex: 1000, maxWidth: '500px', margin: 'auto', borderRadius: '8px', padding: '2rem', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)' }}>
                    <h2 style={headingStyle}>Sell Your NuCoin (NUC) – OTC Buyback Available</h2>
                    <form className="otc-form-label" onSubmit={handleSubmit}>
                        {renderInput("wallet_id", "Wallet ID", "text")}
                        {renderInput("amount_to_sell", "Amount of NUC to Sell (Maximum 50,000 NUC)", "number", 50000)}
                        {renderInput("name", "Full Legal Name", "text")}
                        {renderInput("mobile_number", "Mobile Number", "text")}
                        {renderInput("email", "Email Address", "email")}
                        {renderInput("preferred_stablecoin", "Preferred Stablecoin (USDT, USDC, etc.)", "text")}
                        {renderInput("country_of_residence", "Country of Residence", "text")}
                        {renderInput("kyc_verification_status", "KYC Verification Status", "text")}

                        <label className="form-label" style={labelStyles}>Identification Document (Passport, Identity Card, Driver's License)</label>
                       <p className="form-label-p" style={{ fontSize: '0.85rem', marginBottom: '6px', color: '#aaa' }}>
  Max file size: 10MB
</p>
                        <input
                            type="file"
                            name="kyc_image"
                            accept="image/*"
                            onChange={handleChange}
                            style={inputStyles}
                        />
                        {formErrors.kyc_image && <p style={errorTextStyle}>{formErrors.kyc_image}</p>}

                        <label className="form-label" style={labelStyles}>Selfie Image</label>
                        <p className="form-label-p" style={{ fontSize: '0.85rem', marginBottom: '6px', color: '#aaa' }}>
  Max file size: 10MB
</p>
                        <input
                            type="file"
                            name="selfie_image"
                            accept="image/*"
                            onChange={handleChange}
                            style={inputStyles}
                        />
                        {formErrors.selfie_image && <p style={errorTextStyle}>{formErrors.selfie_image}</p>}

                        <label className="form-label" style={labelStyles}>Are you a Miner?</label>
                        <select
                            name="is_miner"
                            onChange={handleChange}
                            value={formData.is_miner}
                            style={inputStyles}
                        >
                            <option value="no">No</option>
                            <option value="yes">Yes</option>
                        </select>

                        {formData.is_miner === "yes" && (
                            <>
                                <label className="form-label" style={labelStyles}>Miner Position</label>
                                <select
                                    name="miner_position"
                                    onChange={handleChange}
                                    value={formData.miner_position}
                                    style={inputStyles}
                                >
                                    <option value="">Select Miner Position</option>
                                    <option value="silver">Silver</option>
                                    <option value="gold">Gold</option>
                                    <option value="diamond">Diamond</option>
                                    <option value="spac">Spac</option>
                                    <option value="employer">Employer</option>
                                    <option value="governance">Governance</option>
                                    <option value="platinum">Platinum</option>
                                </select>
                                {formErrors.miner_position && <p style={errorTextStyle}>{formErrors.miner_position}</p>}
                            </>
                        )}

                        <button type="submit" style={buttonStyles}>Submit</button>
                    </form>

                    {loading && (
                        <div style={loadingStyles}>
                            <div className="loader"></div>
                            <p>Submitting your sale...</p>
                        </div>
                    )}

                    {successMessage && <p className="res-message" style={successMessageStyles}>{successMessage}</p>}
                    {errorMessage && <p className="res-message" style={errorMessageStyles}>{errorMessage}</p>}
                </section>
            </main>
            <Footer />
        </>
    );

    function renderInput(name, label, type, min = undefined) {
        return (
            <>
                <label className="form-label" style={labelStyles}>{label}</label>
                <input
                    type={type}
                    name={name}
                    placeholder={label}
                    onChange={handleChange}
                    value={formData[name]}
                    min={min}
                    style={inputStyles}
                />
                {formErrors[name] && <p style={errorTextStyle}>{formErrors[name]}</p>}
            </>
        );
    }
}

const inputStyles = {
    width: '100%',
    padding: '12px',
    marginBottom: '12px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxSizing: 'border-box',
};

const headingStyle = {
    paddingBottom: '31px',
    color: '#0cc2ff',
    textAlign: 'center',
    marginBottom: '1rem',
    fontFamily: 'Infynyte',
    fontSize: '2rem',
    fontWeight: 600,
    textTransform: 'lowercase'
};

const buttonStyles = {
    width: '95%',
    padding: '12px',
    backgroundColor: 'rgb(0, 229, 255)',
    color: '#000',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    marginTop: '20px',
};

const loadingStyles = {
    textAlign: 'center',
    color: '#0cc2ff',
    fontSize: '1.2rem',
    marginTop: '20px',
};

const successMessageStyles = {
    backgroundColor: '#28a745',
    color: 'white',
    padding: '12px',
    borderRadius: '8px',
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '1.2rem',
};

const errorMessageStyles = {
    backgroundColor: '#dc3545',
    color: 'white',
    padding: '12px',
    borderRadius: '8px',
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '1.2rem',
};

const errorTextStyle = {
    color: "red",
    fontSize: "0.9rem",
    marginBottom: "10px",
};

const labelStyles = {
    display: 'block',
    marginBottom: '10px',
};


